export default "__VITE_ASSET__B5xQ8s4q__"